import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import config from 'constants/apiConfig';
import { internalLayersKeys } from './queryKeys';
import { buildSearchQueryParams } from 'hooks/shared/buildSearchQueryParams';
import type {
  InternalLayer,
  ListInternalLayersFilter,
  ListInternalLayersQuery,
  ListLayersResponse,
} from './types';

export const useListInternalLayersQuery = (query: ListInternalLayersQuery) => {
  return useQuery({
    queryKey: internalLayersKeys.list(query),
    queryFn: async () => {
      const searchParams =
        buildSearchQueryParams<ListInternalLayersFilter>(query);

      const resp = await axios.get<ListLayersResponse<InternalLayer>>(
        config.apiGateway.internal_layers,
        {
          params: {
            ...searchParams,
            // API needs to be updated to "perPage"
            per_page: searchParams.perPage,
            include: 'incident',
          },
        }
      );

      return resp.data;
    },
  });
};
